import React from 'react';
import { Link } from 'react-router-dom';
import { Badge, Card, Group, Stack, Text } from '@mantine/core';

export default function CollectionCard({
  to,
  title,
  meta,
  badge,
  badgeColor = 'gray',
  thumbnail,
  children,
}) {
  return (
    <Card
      component={to ? Link : undefined}
      to={to}
      style={{ textDecoration: 'none' }}
    >
      <Group justify="space-between" align="flex-start" wrap="nowrap">
        <Group wrap="nowrap" gap="sm" style={{ minWidth: 0 }} align="flex-start">
          {thumbnail}
          <Stack gap={4} style={{ minWidth: 0 }}>
            <Text fw={700} c="dark" truncate>
              {title}
            </Text>
            {meta}
          </Stack>
        </Group>
        {badge && (
          <Badge
            size="sm"
            variant="light"
            color={badgeColor}
            style={{ flexShrink: 0 }}
          >
            {badge}
          </Badge>
        )}
        {children}
      </Group>
    </Card>
  );
}
